module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('Label', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required,
      "bigLabel": _vm.bigLabel
    }
  }, [(!_vm.mask) ? _c('input', {
    staticClass: "input__field",
    class: _vm.classes,
    attrs: {
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "autofocus": _vm.autofocus,
      "aria-label": _vm.ariaLabel,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "autocomplete": _vm.autocomplete
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.input,
      "blur": _vm.blur
    }
  }) : _c('MaskedInput', {
    staticClass: "input__field",
    class: _vm.classes,
    attrs: {
      "type": _vm.inputType,
      "value": _vm.value,
      "readonly": _vm.readonly,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "aria-label": _vm.ariaLabel,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "mask": _vm.mask
    },
    on: {
      "input": _vm.input,
      "blur": _vm.blur
    }
  }), (_vm.type === 'password') ? _c('span', {
    staticClass: "input__after",
    on: {
      "click": _vm.togglePass
    }
  }) : _vm._e()], 1), (_vm.vError) ? _c('div', {
    staticClass: "input__error",
    class: {
      'input__error_sidebar': _vm.sidebar
    }
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3a5f26","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/form/components/input/Input.vue
// module id = 8ccf15f3388102bbc2da
// module chunks = 89